import { render, staticRenderFns } from "./technical-error.vue?vue&type=template&id=0c128baa&scoped=true&lang=pug"
import script from "./technical-error.vue?vue&type=script&lang=js"
export * from "./technical-error.vue?vue&type=script&lang=js"
import style0 from "@ui-common/vue-feedback/dist/vue-feedback.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./technical-error.vue?vue&type=style&index=1&id=0c128baa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c128baa",
  null
  
)

export default component.exports